import {loadSubContractAccrualData} from "./subcontract-accrual";
import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import {loadMaterialAccrual} from "./material-equipment-accrual";

export default function () {
    let pmData = $('#projectManager').data('kendoDropDownList').dataSource.data();
    if (pmData.length > 2) {
        generatePmHtmlList(pmData);
    }
}

const generatePmHtmlList = (pmData) => {
    let $container = $('.js-no-results');
    if ($container.length) {
        $container.html('');
        pmData.forEach(element => {
            if (element.pmNumber <= 0) return;

            let $template = $($('#pmListTemplate').html()),
                $number = $template.find('[name=number]'),
                $name = $template.find('[name=name]'),
                $status = $template.find('[name=status]'),
                status = parseInt(element.approvalStatus);

            $name.text(element.pmName);
            $number.text(element.pmNumber);

            switch (status) {
                case 0 : {
                    $status.text('Open');
                    $status.addClass('tag--red');
                    break;
                }
                case 1: {
                    $status.text('Ready');
                    $status.addClass('tag--yellow');
                    break;
                }
                case 2 : {
                    $status.text('Approved');
                    $status.addClass('tag--green');
                    break;
                }
                default : {
                    $status.text('Approved');
                    $status.addClass('tag--green');
                }
            }

            $container.append($template);
        })

        setPageTag();
    }
}

const setPageTag = () => {
    let tags = ["Open Accruals", "Current PM Accrual Status", "PMs with open accruals", "Accrual Statuses"],
        $pageTag = $('.tag.t-large.tag--green');

    $pageTag.text(tags[parseInt(Math.random() * tags.length)])
}

export const approveNothingEvent = () => {
    const $approveNothingButton = $('.js-approve-nothing');

    if ($approveNothingButton.length) {
        const page = $approveNothingButton.data('page');
        //_page = page;
        $approveNothingButton.on('click', function () {
            let url = '/Account/Accruals/SubContractNoAccrualApprove'
            let reload = loadSubContractAccrualData;
            if (page === 'materials') {
                url = '/Account/Accruals/MaterialNoAccrualApprove';
                reload = loadMaterialAccrual;
            }

            const pin = $approveNothingButton.parents('form').find('[name="pin"]').val();

            if (pin === '') {
                showErrorNotification("Please Enter Pin");
                return;
            }

            let data = {
                qid: $('#quarter').data('kendoDropDownList').value(),
                pin: pin
            };

            $.post(url, data, function (response) {
                if (response.success === true) {
                    showSuccessNotification('Successfully Approved');
                    reload();
                } else {
                    if (response.success === false) {
                        showErrorNotification("Unable to save approval");
                    } else {
                        showErrorNotification(response);
                    }
                }
            })
        });
    }
}

export const showNoApprovals = () => {
    const pmData = $('#projectManager').data('kendoDropDownList').dataSource._data;
    if (pmData.length > 1 && pmData[2].quarterStatus === false) {
        $('.js-no-approvals').hide();
    } else {
        $('.js-no-approvals').show();
    }
}

export const getNoApprovals = () => {
    return new Promise((resolve, reject) => {
        const page = $('.js-approve-nothing').data('page');
        let url = '/Account/Accruals/GetNoSubcontractAccrualsApproval';
        if (page === 'materials') {
            url = '/Account/Accruals/GetNoMaterialAccrualsApproval';
        }
        $.post(url, {qid: $('#quarter').data('kendoDropDownList').value()}, function (response) {
            if (response.approved) {
                $('.js-not-approved').remove();
                $('.js-approver-name').text(response.approver.FullName);
                $('.js-approver-date').text(new Date(response.approver.ApprovalDate).toDateString());
                resolve();
            } else {
                $('.js-approved').remove();
                resolve();
            }
        });
        return this;
    });
}
